import posthog from 'posthog-js';

// Auth
export const trackUserLoggedIn = (method: 'password' | 'magic_link') =>
  posthog.capture('user_logged_in', { method });

export const trackForgotPasswordRequested = () =>
  posthog.capture('forgot_password_requested');

export const trackAccessRequested = () =>
  posthog.capture('access_requested');

// Navigation
export const trackPageViewed = (page: 'dashboard' | 'library' | 'collections' | 'admin') =>
  posthog.capture('page_viewed', { page });

// Cards
export const trackCardOpened = (cardId: number) =>
  posthog.capture('card_opened', { card_id: cardId });

export const trackCardCreated = (method: 'manual' | 'ai_prompt') =>
  posthog.capture('card_created', { method });

export const trackCardUpdatedWithAI = (cardId: number) =>
  posthog.capture('card_updated_with_ai', { card_id: cardId });

export const trackCardMoved = (cardId: number) =>
  posthog.capture('card_moved', { card_id: cardId });

export const trackCardReviewed = (cardId: number) =>
  posthog.capture('card_reviewed', { card_id: cardId });

// Practice
type PracticeType = 'card' | 'folder' | 'category';

export const trackPracticeStarted = (type: PracticeType) =>
  posthog.capture('practice_started', { type });

export const trackPracticeCompleted = (type: PracticeType) =>
  posthog.capture('practice_completed', { type });

export const trackPracticeAbandoned = (type: PracticeType) =>
  posthog.capture('practice_abandoned', { type });

// Collections
export const trackCollectionCreated = () =>
  posthog.capture('collection_created');

export const trackCollectionSelected = (instanceId: number) =>
  posthog.capture('collection_selected', { instance_id: instanceId });

// AI Generation
type GenerationType = 'phrases' | 'collocations' | 'synonyms' | 'antonyms' | 'image' | 'story' | 'folder';

export const trackAIGenerated = (type: GenerationType, cardId?: number) =>
  posthog.capture('ai_generated', { type, card_id: cardId });

export const trackImageSaved = (cardId: number) =>
  posthog.capture('ai_image_saved', { card_id: cardId });

export const trackStorySaved = () =>
  posthog.capture('ai_story_saved');

export const trackAIFolderCreated = () =>
  posthog.capture('ai_folder_created');

export const trackArrangeWithAIApplied = () =>
  posthog.capture('arrange_with_ai_applied');

// Q&A Practice
export const trackQAPracticeStarted = () =>
  posthog.capture('practice_started', { type: 'qa' });

export const trackQAPracticeCompleted = (questionsAnswered: number) =>
  posthog.capture('practice_completed', { type: 'qa', questions_answered: questionsAnswered });
